export const extractScheduleArray = (scheduleData) => {
  const normalizeScheduleEntries = (scheduleArray) => {
    if (!Array.isArray(scheduleArray)) {
      return [];
    }

    return scheduleArray.map((item) => {
      if (!item || typeof item !== 'object' || !item.date) {
        return item;
      }

      return {
        ...item,
        openingTime: item.openingTime || (item.open ? `${item.date}T${item.open}` : null),
        closingTime: item.closingTime || (item.close ? `${item.date}T${item.close}` : null)
      };
    });
  };

  if (Array.isArray(scheduleData)) {
    return normalizeScheduleEntries(scheduleData);
  }

  if (Array.isArray(scheduleData?.schedule) && scheduleData.schedule.length > 0) {
    return normalizeScheduleEntries(scheduleData.schedule);
  }

  // DESTINATION responses expose the schedule under parks[0].schedule; fall back when top-level is empty
  if (Array.isArray(scheduleData?.parks) && Array.isArray(scheduleData.parks[0]?.schedule)) {
    return normalizeScheduleEntries(scheduleData.parks[0].schedule);
  }

  if (Array.isArray(scheduleData?.schedule)) {
    return normalizeScheduleEntries(scheduleData.schedule);
  }

  return [];
};

export const getOpeningHoursFromSchedule = (scheduleArray, referenceDate = new Date().toISOString().split('T')[0]) => {
  if (!Array.isArray(scheduleArray) || scheduleArray.length === 0) {
    return null;
  }

  const isOperatingDay = (item) => item?.date && (!item.type || item.type === 'OPERATING' || item.type === 'PARK_OPEN');

  const todaySchedule = scheduleArray.find(
    (item) => item.date === referenceDate && isOperatingDay(item)
  );

  if (todaySchedule) {
    return {
      openingTime: todaySchedule.openingTime,
      closingTime: todaySchedule.closingTime,
      date: todaySchedule.date,
      isFuture: false
    };
  }

  const nextSchedule = scheduleArray
    .filter((item) => item.date > referenceDate && isOperatingDay(item))
    .sort((a, b) => new Date(a.date) - new Date(b.date))[0];

  if (!nextSchedule) {
    return null;
  }

  return {
    openingTime: nextSchedule.openingTime,
    closingTime: nextSchedule.closingTime,
    date: nextSchedule.date,
    isFuture: true
  };
};
